import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { XCircle, Save } from "react-feather";
import { useForm } from "react-hook-form";
import { FILE, GET, POST, PUT } from "../../../api/adminApi";
import { toast } from "react-toastify";

function NewsCreateUpdate() {
  let { id } = useParams();
  const history = useHistory();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: "",
      text: "",
      photo: "",
      thumbPhoto: "",
    },
  });

  const [data, setData] = useState({
    title: "",
    text: "",
    photo: "",
    thumbPhoto: "",
  });

  async function create(formData) {
    let response;
    const payload = {
      ...formData,
      photo: data.photo,
      thumbPhoto: data.thumbPhoto,
      published: true,
    };

    if (id) {
      response = await PUT("/services/admin/api/news", {
        ...payload,
        id: parseInt(id),
      });
    } else {
      response = await POST("/services/admin/api/news", payload);
    }

    if (response?.success) {
      history.push("/admin/news");
      toast.success(id ? "Новость обновлена" : "Новость добавлена");
    }
  }

  // Reusable function to handle both main photo and thumb photo uploads
  async function handleFileUpload(e, fieldName) {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      const formData = new FormData();
      formData.append("image", image);

      await FILE("/services/admin/api/news-image-upload", formData)
          .then((response) => {
            let url = response?.url;
            if (!url && typeof response === "string") {
              url = response;
            }

            if (url) {
              setData((prev) => ({ ...prev, [fieldName]: url }));
              setValue(fieldName, url);
            }
          })
          .catch((error) => console.log(error));
    }
  }

  useEffect(() => {
    async function getNewsItem() {
      try {
        const response = await GET("/services/admin/api/news/" + id);
        if (response) {
          setData((prev) => ({
            ...prev,
            photo: response.photo,
            thumbPhoto: response.thumbPhoto
          }));
          setValue("title", response.title);
          setValue("text", response.text);
          setValue("photo", response.photo);
          setValue("thumbPhoto", response.thumbPhoto);
        }
      } catch (e) {
        console.error(e);
      }
    }

    if (id) {
      getNewsItem();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
      <div className="mb-2 mx-3 ">
        <h3 className="mb-5 mt-5">
          {id ? "Изменить новость" : "Добавить новость"}
        </h3>
        <div className="admin-card py-4">
          <form onSubmit={handleSubmit(create)} autoComplete="off">
            <div className="d-flex pt-12">

              {/* Left Column for Images */}
              <div className="" style={{ width: "350px" }}>

                {/* Main Photo Field */}
                <div className="admin-field mb-5">
                  <div className="d-flex w-100">
                    <div className="admin-label mr-md-3" style={{ width: "80px" }}>
                      <label className="mb-0">Фото</label>
                    </div>
                    <div className="position-relative">
                      <div
                          className="image-block"
                          style={{
                            width: "200px",
                            minWidth: "100px",
                            minHeight: "200px",
                            border: "1px dashed #D4D3D6",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            padding: "10px",
                          }}
                      >
                        Перетащите сюда файлы для загрузки
                      </div>
                      <input
                          onChange={(e) => handleFileUpload(e, "photo")}
                          type="file"
                          style={{
                            width: "200px",
                            minWidth: "100px",
                            minHeight: "200px",
                            opacity: "0",
                            top: 0,
                            zIndex: 3,
                            position: "absolute",
                          }}
                          className="cursor border border-radius-3 box outline-none color-grey"
                      />
                      {data.photo && (
                          <div
                              className="position-absolute cursor border-radius-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                top: 0,
                                zIndex: 2,
                              }}
                          >
                            <img
                                className="w-100 h-100 background-white border box-shadow"
                                src={
                                  data.photo?.startsWith("http")
                                      ? data.photo
                                      : "https://bo.akfacomfort.uz" + data.photo
                                }
                                alt="Main"
                                style={{ objectFit: "cover" }}
                            />
                          </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Thumb Photo Field */}
                <div className="admin-field">
                  <div className="d-flex w-100">
                    <div className="admin-label mr-md-3" style={{ width: "80px" }}>
                      <label className="mb-0">Превью</label>
                    </div>
                    <div className="position-relative">
                      <div
                          className="image-block"
                          style={{
                            width: "150px",
                            minWidth: "100px",
                            minHeight: "150px",
                            border: "1px dashed #D4D3D6",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            padding: "10px",
                            fontSize: "12px"
                          }}
                      >
                        Загрузить миниатюру
                      </div>
                      <input
                          onChange={(e) => handleFileUpload(e, "thumbPhoto")}
                          type="file"
                          style={{
                            width: "150px",
                            minWidth: "100px",
                            minHeight: "150px",
                            opacity: "0",
                            top: 0,
                            zIndex: 3,
                            position: "absolute",
                          }}
                          className="cursor border border-radius-3 box outline-none color-grey"
                      />
                      {data.thumbPhoto && (
                          <div
                              className="position-absolute cursor border-radius-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                top: 0,
                                zIndex: 2,
                              }}
                          >
                            <img
                                className="w-100 h-100 background-white border box-shadow"
                                src={
                                  data.thumbPhoto?.startsWith("http")
                                      ? data.thumbPhoto
                                      : "https://bo.akfacomfort.uz" + data.thumbPhoto
                                }
                                alt="Thumb"
                                style={{ objectFit: "cover" }}
                            />
                          </div>
                      )}
                    </div>
                  </div>
                </div>

              </div>

              {/* Right Column for Text Inputs */}
              <div className="" style={{ width: "500px" }}>
                <div className="admin-field">
                  <div className="d-flex w-100">
                    <div className="admin-label mr-md-3">
                      <label className="mb-0">Заголовок</label>
                    </div>
                    <input
                        {...register("title", { required: true })}
                        placeholder=""
                        className="input-control"
                    />
                  </div>
                  {errors.title && (
                      <div className="text-danger mt-1 fz12">Обязательное поле</div>
                  )}
                </div>
                <div className="admin-field">
                  <div className="d-flex w-100">
                    <div className="admin-label mr-md-3">
                      <label className="mb-0">Текст</label>
                    </div>
                    <textarea
                        {...register("text", { required: true })}
                        placeholder=""
                        className="input-control"
                        style={{ minHeight: "150px" }}
                    />
                  </div>
                  {errors.text && (
                      <div className="text-danger mt-1 fz12">Обязательное поле</div>
                  )}
                </div>
              </div>
            </div>

            <div className="btn-postion d-flex justify-content-end mt-4">
              <Link to="/admin/news" className="mr-3">
                <button className="btn text-white btn-bg-primary d-flex align-items-center">
                  <XCircle size={14} className="mr-2" />
                  Отмена
                </button>
              </Link>
              <button
                  className="btn text-white btn-bg-success d-flex align-items-center"
                  type="submit"
              >
                <Save size={14} className="mr-2" />
                Сохранить
              </button>
            </div>
          </form>
        </div>
      </div>
  );
}

export default NewsCreateUpdate;